const WRAPPER_CLASSES = {
  inline: "flex justify-center py-12",
  wide: "flex items-center justify-center py-20",
  page: "min-h-screen flex items-center justify-center",
} as const;

type SpinnerVariant = keyof typeof WRAPPER_CLASSES;

export function Spinner({ variant = "inline" }: { variant?: SpinnerVariant }) {
  return (
    <div className={WRAPPER_CLASSES[variant]}>
      <div className="animate-spin rounded-full h-8 w-8 border-b-2 border-primary" />
    </div>
  );
}
